import { Skeleton } from '@avanta/shared/components/ui/Skeleton';
import { type ReactElement } from 'react';

const WEEKDAY_HEADERS = 7;
const CALENDAR_ROWS = 5;
const DAYS_PER_WEEK = 7;
const TIME_SLOTS_COUNT = 6;

const CalendarSkeleton = (): ReactElement => (
  <div className="w-full border border-teal-300 am-lg:border-transparent rounded-xl px-2 am-lg:p-0 p-3">
    <div className="flex flex-col gap-4 px-3">
      <div className="relative flex items-center justify-center h-8">
        <Skeleton className="absolute left-0 size-8 rounded-md" />
        <Skeleton className="h-5 w-24" />
        <Skeleton className="absolute right-0 size-8 rounded-md" />
      </div>
      <div className="flex flex-col">
        <div className="flex">
          {Array.from({ length: WEEKDAY_HEADERS }).map((_, index) => (
            <div key={`weekday-${index}`} className="flex-1 flex justify-center">
              <Skeleton className="h-4 w-6" />
            </div>
          ))}
        </div>
        {Array.from({ length: CALENDAR_ROWS }).map((_, rowIndex) => (
          <div key={`week-${rowIndex}`} className="flex w-full mt-2">
            {Array.from({ length: DAYS_PER_WEEK }).map((_, dayIndex) => (
              <div
                key={`day-${rowIndex}-${dayIndex}`}
                className="flex-1 flex items-center justify-center"
              >
                <Skeleton className="size-9 rounded-full" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

const TimeSlotsSkeleton = (): ReactElement => (
  <div className="flex flex-col gap-2 am-lg:">
    <Skeleton className="h-5 w-24" />
    <div className="flex am-lg:flex-col gap-3.5 am-lg:gap-4 flex-col justify-between h-full">
      <div className="grid grid-cols-5 am-lg:grid-cols-3 gap-2">
        {Array.from({ length: TIME_SLOTS_COUNT }).map((_, index) => (
          <Skeleton key={`slot-${index}`} className="h-8 w-full rounded" />
        ))}
      </div>
      <div className="flex flex-col gap-2 justify-between">
        <Skeleton className="h-px w-full" />
        <Skeleton className="h-5 w-36" />
        <Skeleton className="h-5 w-16" />
      </div>
    </div>
  </div>
);

export const SearchDateTimeStepSkeleton = (): ReactElement => (
  <div className="flex flex-col gap-8 am-lg:gap-10 transition-opacity w-full">
    <div className="flex flex-col gap-4">
      <Skeleton className="h-5 w-56" />
      <div className="grid am-lg:grid-cols-2 gap-4 am-lg:gap-12 p-0 am-lg:p-6 border border-transparent am-lg:border-teal-300 rounded-xl">
        <CalendarSkeleton />
        <TimeSlotsSkeleton />
      </div>
    </div>
  </div>
);
